// extracted by mini-css-extract-plugin
export default {"toolbox":"toolbox__Toolbox__7rZ6z"};